/* Плавающая кнопка и окно саппорт-чата. Ниже модалов (у них z-index 1000):
   открытое окно входа или магии должно перекрывать чат, а не наоборот. */

/* Треугольник, уложенный в правый нижний угол: гипотенуза смотрит внутрь
   экрана, внутри — «?» и очкастый смайлик. Сам <button> — прозрачный квадрат,
   видимую форму даёт .wedge с clip-path. */
.fab {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 900;
  width: 76px;
  height: 76px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  /* Кликабелен весь квадрат — по краям треугольника промахнуться легко,
     а ничего другого в самом углу экрана всё равно нет. */
}

.wedge {
  position: absolute;
  inset: 0;
  clip-path: polygon(100% 0, 100% 100%, 0 100%);
  background: var(--btn-primary-bg);
}

.fab:hover .wedge {
  background: var(--btn-primary-hover);
}

.fabContent {
  position: absolute;
  right: 4px;
  bottom: 10px;
  display: flex;
  align-items: center;
  gap: var(--sp-1);
  /* Вдоль гипотенузы: контент лежит по диагонали уголка. */
  transform: rotate(-45deg);
  color: var(--btn-primary-fg);
}

.question {
  font-size: var(--fs-lg);
  font-weight: 700;
  line-height: 1;
}

.emoji {
  font-size: var(--fs-lg);
  line-height: 1;
}

/* Бейдж стоит в ряду «? 😎 n» внутри повёрнутого контента; доворот на +45°
   ставит цифру вертикально, круг от поворота не меняется. */
.badge {
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: var(--error);
  color: var(--text-inverse);
  font-size: var(--fs-xs);
  font-weight: 600;
  line-height: 1;
  transform: rotate(45deg);
}

/* Окно прибито к правому нижнему углу — на месте спрятанного уголка. Ширину
   и высоту задаёт инлайн-стиль из состояния (ручка .resize), здесь — потолки,
   чтобы окно не вылезло за экран на любом размере. */
.panel {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 950;
  display: flex;
  flex-direction: column;
  max-width: calc(100vw - var(--sp-6));
  max-height: calc(100vh - var(--sp-6));
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius-lg) 0 0 0;
  background: var(--surface);
  box-shadow: var(--shadow-modal);
  overflow: hidden;
}

/* Ручка изменения размера: левый верхний угол — тянуть влево и вверх. */
.resize {
  position: absolute;
  top: 0;
  left: 0;
  width: 16px;
  height: 16px;
  cursor: nwse-resize;
  z-index: 1;
  /* Две диагональные насечки, чтобы ручку было видно. */
  background:
    linear-gradient(135deg, var(--border-strong) 0 1px, transparent 1px 4px, var(--border-strong) 4px 5px, transparent 5px) no-repeat;
  background-size: 12px 12px;
  background-position: 2px 2px;
  touch-action: none;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--sp-4) var(--sp-5) var(--sp-4) calc(var(--sp-5) + 12px);
  border-bottom: 1px solid var(--border);
  background: var(--surface-2);
}

.title {
  font-size: var(--fs-md);
  font-weight: 600;
  color: var(--text);
}

/* «Свернуть»: переписка не пропадает, окно просто уступает место уголку. */
.minimize {
  border: none;
  background: none;
  color: var(--text-2);
  font-size: var(--fs-lg);
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  padding: 0 var(--sp-2);
}

.minimize:hover {
  color: var(--text);
}

.list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  padding: var(--sp-5);
}

.empty {
  margin: auto;
  color: var(--text-3);
  font-size: var(--fs-sm);
  text-align: center;
  max-width: 26ch;
}

.mine,
.theirs {
  max-width: 85%;
  padding: var(--sp-3) var(--sp-4);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
}

.mine {
  align-self: flex-end;
  background: var(--flight-bg);
  border: 1px solid var(--border);
}

.theirs {
  align-self: flex-start;
  background: var(--surface-2);
  border: 1px solid var(--border);
}

.text {
  margin: 0;
  font-size: var(--fs-md);
  color: var(--text);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.meta {
  font-size: var(--fs-xs);
  color: var(--text-3);
}

.who {
  font-weight: 600;
}

.error {
  margin: 0;
  padding: var(--sp-2) var(--sp-5);
  color: var(--error);
  font-size: var(--fs-sm);
}

.composer {
  display: flex;
  align-items: flex-end;
  gap: var(--sp-3);
  padding: var(--sp-4) var(--sp-5);
  border-top: 1px solid var(--border);
}

/* Ввод растягивается по вертикали — штатной ручкой textarea. */
.input {
  flex: 1;
  resize: vertical;
  min-height: 0;
  max-height: 200px;
}

/* Вложения: картинка — сразу в пузыре, остальное — ссылкой. */
.image {
  max-width: 100%;
  max-height: 200px;
  border-radius: var(--radius);
  border: 1px solid var(--border);
}

.fileLink {
  font-size: var(--fs-md);
  color: var(--text);
  overflow-wrap: anywhere;
}

.attach {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex: none;
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius);
  background: var(--surface-2);
  font-size: var(--fs-lg);
  line-height: 1;
  cursor: pointer;
}

.attach:disabled {
  opacity: 0.45;
  cursor: default;
}

/* Отправка — бумажный самолётик. */
.send {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex: none;
  border: var(--bw) solid var(--btn-primary-bg);
  border-radius: var(--radius);
  background: var(--btn-primary-bg);
  color: var(--btn-primary-fg);
  cursor: pointer;
}

.send:hover:not(:disabled) {
  background: var(--btn-primary-hover);
}

.send:disabled {
  opacity: 0.45;
  cursor: default;
}
